import { Injectable } from '@angular/core';
import { SessionAwareMultiStore } from '../../../../shared/stores/session-aware-store';
import { Supplier } from '../models/supplier';

@Injectable({ providedIn: 'root' })
export class SuppliersStore extends SessionAwareMultiStore<Supplier> {}
